export function formatBytes(n: number | null): string {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString();
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString();
}

/** Format the calendar quarter containing the given ISO date.
 * Returns ``"—"`` for null / unparseable input. Q1 = Jan-Mar,
 * Q2 = Apr-Jun, etc. The Dashboard's "Quarter" column uses this
 * against ``latest_encounter_date``. */
export function formatQuarter(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const quarter = Math.floor(d.getUTCMonth() / 3) + 1;
  return `Q${quarter}-${d.getUTCFullYear()}`;
}
